import { AlertCircle } from 'lucide-react';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { AuthShell } from './AuthShell';

export default function AccountVerifyFail() {
  return (
    <AuthShell title="Verification failed">
      <div className="p-6 flex flex-col items-center text-center">
        <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center text-destructive mb-4">
          <AlertCircle className="w-5 h-5" />
        </div>
        <p className="text-sm text-foreground mb-4">
          Something went wrong trying to verify your email. Click the link in your email again.
        </p>
        <Button variant="outline" asChild>
          <Link to="/signin">Back to sign in</Link>
        </Button>
      </div>
    </AuthShell>
  );
}
